// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsTransformationLogsDatatableResultItem = objectOf({
  id: string,
  transformation_name: string,
  transformation_id: string,
  timestamp: string,
  input: maybe(objectOf({})),
  output: maybe(objectOf({})),
  response_body: maybe(objectOf({})),
  result: string,
  details: string,
  endpoint: string,
});

export const isAppsTransformationLogsDatatableResult = objectOf({
  hits: number,
  results: arrayOf(isAppsTransformationLogsDatatableResultItem),
});
